export default __webpack_public_path__ + "static/media/5.715186e1.jpg";